import { allLeadMode, getDefaultCrossSellAction } from 'config';
import {
  ATT,
  BrightspeedV2,
  BuckeyeBroadband,
  QuantumFiber as QuantumFiberProvider,
  CincinnatiBell,
  Comcast,
  Cox,
  FidiumFiber,
  Frontier,
  Grande,
  Mediacom,
  Optimum,
  RCN,
  Spectrum,
  TDS,
  Verizon,
  WOW,
  Wave,
  Windstream,
} from 'config/providers';
import { QuantumFiberTheme } from 'config/themes/QuantumTheme';
import { CheckoutType, ShopType, SingleProviderConfig } from 'types';

export const QuantumFiber: SingleProviderConfig = {
  name: 'QuantumFiber',
  micrositeCode: 'quantumfiber',
  mainProvider: QuantumFiberProvider,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'quantumfiberspecial.com',
  homepage: 'https://quantumfiberspecial.com',
  title: 'QuantumFiber Authorized Dealer',
  fallbackPhoneNumber: '844-571-1154',
  fallbackLeadModePhoneNumber: '844-571-1152',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: QuantumFiberTheme,
  needsDcSession: false,
  source: 'QuantumFiber',
  noOffersRetry: 2,
  getCrossSellAction: getDefaultCrossSellAction,
  getCheckoutType: allLeadMode,
  crossSellProviders: [
    ATT,
    Verizon,
    BrightspeedV2,
    Frontier,
    Windstream,
    CincinnatiBell,
  ],
  updaterCrossSellActive: true,
  updaterCrossSellProviders: [
    Comcast,
    Cox,
    Spectrum,
    Optimum,
    Wave,
    Grande,
    RCN,
    WOW,
    TDS,
    BuckeyeBroadband,
    Mediacom,
    FidiumFiber,
  ],
};
